import {
  WeatherSunny,
  WeatherCloudy,
  WeatherPartlyCloudy,
  WeatherFog,
  WeatherRain,
  WeatherRainHeavy,
  WeatherSnow,
  WeatherThunder,
  WeatherHail,
} from '../assets/svg';

// Map of weather conditions to their corresponding icon components
const WEATHER_ICON_MAP = {
  sun: WeatherSunny,
  clear: WeatherSunny,
  'partly cloudy': WeatherPartlyCloudy,
  cloud: WeatherCloudy,
  overcast: WeatherCloudy,
  mist: WeatherFog,
  fog: WeatherFog,
  'heavy rain': WeatherRainHeavy,
  torrential: WeatherRainHeavy,
  rain: WeatherRain,
  drizzle: WeatherRain,
  snow: WeatherSnow,
  sleet: WeatherSnow,
  ice: WeatherSnow,
  thunder: WeatherThunder,
  storm: WeatherThunder,
  hail: WeatherHail,
};

/**
 * Function: getWeatherIcon
 * @description Returns the appropriate weather icon component based on the weather condition.
 * @param {Object} condition - The weather condition object from the API.
 * @param {string} condition.text - The text description of the weather condition.
 * @returns {JSX.Element|null} - The weather icon component or null if no matching condition is found.
 */
export const getWeatherIcon = (condition) => {
  const code = condition?.text?.toLowerCase() || '';

  // Find the first matching weather condition
  const matchingCondition = Object.keys(WEATHER_ICON_MAP).find((key) => code.includes(key));

  if (!matchingCondition) {
    console.error(`Unknown weather condition: ${code}`);
    return null;
  }

  const WeatherComponent = WEATHER_ICON_MAP[matchingCondition];
  return <WeatherComponent />;
};

/**
 * Function: getWeatherForDate
 * @description Retrieves the weather condition for a specific date from the weather data.
 * @param {Object} weatherData - The weather forecast data from the API.
 * @param {Object} weatherData.forecast - The forecast object containing daily weather data.
 * @param {Array} weatherData.forecast.forecastday - Array of daily forecasts.
 * @param {Date|string|number} date - The date to get weather for.
 * @returns {Object|null} - The weather condition object for the specified date or null if not found.
 */
export const getWeatherForDate = (weatherData, date) => {
  if (!weatherData?.forecast?.forecastday) return null;

  const dateString = new Date(date).toISOString().split('T')[0];
  const forecastDay = weatherData.forecast.forecastday.find((day) => day.date === dateString);

  return forecastDay ? forecastDay.day.condition : null;
};
